let formatterBR = undefined;

if (formatterBR === undefined){
    formatterBR = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    })
}

export function formatter(moeda) {
    if(moeda === 'BRL') return Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });
    else return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: moeda,
    });
}

export default formatterBR

/* 
export default function formatToCurrency(value, formatter) {
    const valueFormatted = formatter.format(value);
    console.log(valueFormatted)
    if(valueFormatted[0] === '-'){
        let parts = valueFormatted.split(/(\s+)/);
        console.log(parts);
        parts[0] = parts[0].replace(/-/, '');
        parts[2] = '-' + parts[2];
        console.log(parts);
        return parts.join("");
    }
    else
        return valueFormatted;
} */